import { useEffect } from 'react';

import { getIsNativePlatform, isTouchPrimary } from 'utils/platform';

const useAutofocusSearchOnOpen = ({ isOpen, inputRef }) => {
  useEffect(() => {
    if (!isOpen || isTouchPrimary() || getIsNativePlatform()) {
      return;
    }

    const rafIds = [];

    rafIds.push(
      requestAnimationFrame(() => {
        rafIds.push(requestAnimationFrame(() => inputRef.current?.focus()));
      }),
    );

    return () => rafIds.forEach(id => cancelAnimationFrame(id));
  }, [isOpen, inputRef]);
};

export default useAutofocusSearchOnOpen;
